export default {
  autoPlay: false,
  darkmode: false,
};
